import React, { useEffect, useRef } from "react";
import "./Comment.css";

const CommentTextarea = ({ value, onChange, placeholder = "답변을 입력하세요.", style = {}, minHeight = 100, className = "community-answer" }) => {
  const textareaRef = useRef(null);

  // 텍스트 영역 높이 자동 조절 함수
  const autoResizeTextarea = (e) => {
    const { target } = e;
    target.style.height = "auto";
    target.style.height = `${target.scrollHeight}px`;
    target.style.overflow = "visible";

    onChange(e);
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
      textareaRef.current.style.overflow = "visible";
    }
  }, [value]);

  return (
    <textarea
      autoFocus
      ref={textareaRef}
      value={value}
      onChange={autoResizeTextarea}
      placeholder={placeholder}
      className={className}
      style={{
        minHeight: `${minHeight}px`,
        resize: "none",
        overflow: "visible",
        height: "auto",
        ...style,
      }}
    />
  );
};

export default CommentTextarea;
